<template>
  <div class="footer">
    <div class="contain">
      <div class="three wow fadeInUp clearfix">
        <div class="whiteLogo fl">
          <img src="./img/whiteLogo.png" srcset="./img/whiteLogo@2x.png 2x">
        </div>
        <div class="whiteLogoMobil fl">
          <img src="./img/mobile_footer_logo.png" srcset="./img/mobile_footer_logo@2x.png 2x">
        </div>
        <div class="w100 fr">
          <div class="linkList fl">
            <ul>
              <li>Maro</li>
              <li><a href="https://ma.ro/#/" target="_blank">{{$t('footer_home')}}</a></li>
              <li><a href="https://ma.ro/#/about" target="_blank">{{$t('footer_about')}}</a></li>
              <li><a href="https://ma.ro/#/ecosystem" target="_blank">{{$t('footer_ecosystem')}}</a></li>
              <li><a href="https://dev.ma.ro/#/" target="_blank">{{$t('footer_developer')}}</a></li>
            </ul>
          </div>
          <!-- <div class="linkList fl">
            <ul>
              <li>Docs</li>
              <li><a href="https://d1u6eqogwsdivn.cloudfront.net/whitepaper_v2/TTC_Whitepaper_EN.pdf" target="_blank">Whitepaper</a></li>
              <li><a href="https://d1u6eqogwsdivn.cloudfront.net/whitepaper_v2/TTC_Whitepaper_KR.pdf" target="_blank">백서</a></li>
              <li><a href="https://d1u6eqogwsdivn.cloudfront.net/whitepaper_v2/TTC_Whitepaper_CN.pdf" target="_blank">白皮书</a></li>
              <li><a href="https://d1u6eqogwsdivn.cloudfront.net/whitepaper_v2/TTC_Whitepaper_VI.pdf" target="_blank">Sách trắng</a></li>
              <li><a href="https://d1u6eqogwsdivn.cloudfront.net/whitepaper_v2/TTC_Whitepaper_EN.pdf" target="_blank">Белая книга</a></li>
            </ul>
          </div> -->
          <div class="media fl">
            <div class="tit">{{$t('footer_media')}}</div>
            <ul class="clearfix">
              <li v-for="(item, index) in iconList" :key="index">
                <a v-if="item.type === 'qr'" @mouseenter="item.show = true" @mouseleave="item.show = false">
                 <img v-show='item.show' class="qrcode qrWehat" :src="item.hoverIcon">
                 <img  :src="item.icon" >
               </a>
               <a v-else-if="item.type === 'talk'" :href="item.link" target="_blank" @mouseenter="item.show = true" @mouseleave="item.show = false">
                 <img v-show='item.show' class="qrcode" :src="item.hoverIcon">
                 <img  :src="item.icon">
               </a>
                <a v-else :href="item.link" target="_blank" @mouseenter="item.show = true" @mouseleave="item.show = false">
                  <img v-show="item.show" :src="item.hoverIcon" alt="">
                  <img v-show="!item.show" :src="item.icon" alt="">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="lineBox wow fadeInUp clearfix">
        <div class="w100 fr">
          <div class="maro fr">
            <img src="./img/maro_white.png" alt="">
          </div>
          <div class="line fr">
            <Lottie style="width:1060px;" :options="defaultOptions" v-on:animCreated="handleAnimation"/>
          </div>
        </div>
        <ul class="timeList fl">
          <li v-show="animaIndex == 0" :class="{'animation': animaIndex == 0}">
            <p class="p1">{{$t('about_contant4_time1')}}</p>
            <p class="p2">{{$t('about_contant4_time1_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 1" :class="{'animation': animaIndex == 1}">
            <p class="p1">{{$t('about_contant4_time2')}}</p>
            <p class="p2">{{$t('about_contant4_time2_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 2" :class="{'animation': animaIndex == 2}">
            <p class="p1">{{$t('about_contant4_time3')}}</p>
            <p class="p2">{{$t('about_contant4_time3_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 3" :class="{'animation': animaIndex == 3}">
            <p class="p1">{{$t('about_contant4_time4')}}</p>
            <p class="p2">{{$t('about_contant4_time4_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 4" :class="{'animation': animaIndex == 4}">
            <p class="p1">{{$t('about_contant4_time5')}}</p>
            <p class="p2">{{$t('about_contant4_time5_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 5" :class="{'animation': animaIndex == 5}">
            <p class="p1">{{$t('about_contant4_time6')}}</p>
            <p class="p2">{{$t('about_contant4_time6_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 6" :class="{'animation': animaIndex == 6}">
            <p class="p1">{{$t('about_contant4_time7')}}</p>
            <p class="p2">{{$t('about_contant4_time7_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 7" :class="{'animation': animaIndex == 7}">
            <p class="p1">{{$t('about_contant4_time8')}}</p>
            <p class="p2">{{$t('about_contant4_time8_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 8" :class="{'animation': animaIndex == 8}">
            <p class="p1">{{$t('about_contant4_time9')}}</p>
            <p class="p2">{{$t('about_contant4_time9_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 9" :class="{'animation': animaIndex == 9}">
            <p class="p1">{{$t('about_contant4_time10')}}</p>
            <p class="p2">{{$t('about_contant4_time10_txt1')}}</p>
          </li>
          <li v-show="animaIndex == 10" :class="{'animation': animaIndex == 10}">
            <p class="p1">{{$t('about_contant4_time11')}}</p>
            <p class="p2">{{$t('about_contant4_time11_txt1')}}</p>
          </li>
        </ul>
      </div>
      <div class="copyRight wow fadeInUp">
        <a href="https://www.ttc.eco/terms" target="_blank">Terms &amp; Conditions</a>
        <span>ㅣ</span>
        <a href="https://www.ttc.eco/privacy" target="_blank">Privacy Policy</a>
        <span class="rights">&nbsp;Copyright © 2022 TTC Foundation PTE. All rights reserved.</span>
      </div>
    </div>
  </div>
</template>
<script>
import * as animationData from './json/line.json'
import Lottie from 'vue-lottie/src/lottie.vue'
export default {
  components: {
    Lottie
  },
  data () {
    return {
      animaIndex: 0,
      defaultOptions: {
        animationData: animationData,
        autoplay: false
      },
      iconList: [
        {
          show: false,
          link: 'https://medium.com/@ttc.eco',
          icon: require('./img/footer_icon/Medium.png'),
          hoverIcon: require('./img/footer_icon/hover/Medium.png')
        },
        {
          show: false,
          link: 'http://www.facebook.com/ttceco',
          icon: require('./img/footer_icon/facebook.png'),
          hoverIcon: require('./img/footer_icon/hover/facebook.png')
        },
        {
          show: false,
          link: 'https://github.com/TTCECO/Documentation',
          icon: require('./img/footer_icon/github.png'),
          hoverIcon: require('./img/footer_icon/hover/github.png')
        },
        {
          show: false,
          link: 'https://www.reddit.com/r/TTC_Protocol/',
          icon: require('./img/footer_icon/reddit.png'),
          hoverIcon: require('./img/footer_icon/hover/reddit.png')
        },
        {
          show: false,
          link: 'https://twitter.com/TTC_Blockchain',
          icon: require('./img/footer_icon/twitter.png'),
          hoverIcon: require('./img/footer_icon/hover/twitter.png')
        },
        {
          show: false,
          link: 'https://t.me/ttc_official',
          icon: require('./img/footer_icon/telegram.png'),
          hoverIcon: require('./img/footer_icon/hover/telegram.png')
        },
        {
          show: false,
          link: 'https://t.me/ttc_en',
          icon: require('./img/footer_icon/en.png'),
          hoverIcon: require('./img/footer_icon/hover/en.png')
        },
        {
          show: false,
          link: 'https://t.me/ttc_kr',
          icon: require('./img/footer_icon/kr.png'),
          hoverIcon: require('./img/footer_icon/hover/kr.png')
        },
        {
          show: false,
          link: 'https://t.me/ttc_vn',
          icon: require('./img/footer_icon/vn.png'),
          hoverIcon: require('./img/footer_icon/hover/vn.png')
        },
        {
          show: false,
          link: 'https://t.me/ttc_bd',
          icon: require('./img/footer_icon/bd.png'),
          hoverIcon: require('./img/footer_icon/hover/bd.png')
        },
        {
          type: 'talk',
          show: false,
          link: 'https://open.kakao.com/o/gmvFnaN',
          icon: require('./img/footer_icon/TALK.png'),
          hoverIcon: require('./img/footer_icon/hover/TALK.png')
        },
        {
          type: 'qr',
          show: false,
          link: '',
          icon: require('./img/footer_icon/wechat.png'),
          hoverIcon: require('./img/footer_icon/hover/wechat.png')
        }
      ]
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    },
    animaStart () {
      this.anim.play()
      setInterval(() => {
        if (this.animaIndex === 10) {
          this.animaIndex = 0
        } else {
          this.animaIndex += 1
        }
      }, 10000)
    }
  },
  mounted () {
    this.animaStart()
  }
}
</script>
<style lang="less" scoped>
.footer{
  padding-bottom: 100px;
  background:rgba(51, 61, 70, 1);
  .contain{
    padding-top: 100px;
    .three{
      .whiteLogo{
        display: block;
        width: 73px;
        height: 84px;
      }
      .whiteLogoMobil{
        display: none;
        width: 100%;
        margin-bottom: 40px;
        img{
          width: 122px;
        }
      }
      .w100{
        width: auto;
      }
      .media{
        .tit{
          font-size: 16px;
          font-family: Montserrat-SemiBold, Montserrat;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 19px;
          text-align: right;
          margin-bottom: 16px;
        }
        ul{
          max-width: 164px;
          li{
            float: right;
            width: 32px;
            height: 32px;
            margin-left: 12px;
            margin-bottom: 12px;
            &:nth-child(4){
              margin-left: 0;
            }
            &:nth-child(8){
              margin-left: 0;
            }
            &:nth-child(12){
              margin-left: 0;
            }
            a{
              display: inline-block;
              position: relative;
              img{
                width: 100%;
              }
              .qrcode {
                width: 80px;
                max-width: unset;
                position: absolute;
                top: -72px;
                left: -24px;
              }
              .qrWehat {
                width: 140px;
                max-width: unset;
                position: absolute;
                top: -130px;
                left: -55px;
              }
            }
          }
        }
      }
      .linkList{
        width: 300px;
        ul{
          li{
            margin-bottom: 16px;
            font-size: 16px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 19px;
            a{
              font-size: 16px;
              font-family: Montserrat-Regular, Montserrat;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 19px;
              text-decoration: none;
              &:hover{
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    .lineBox{
      padding-top: 80px;
      min-height: 80px;
      // margin-bottom: 40px;
      .timeList{
        width: 20%;
        li{
          .p1{
            font-size: 16px;
            font-family: Montserrat-ExtraLight, Montserrat;
            font-weight: 200;
            color: #FFFFFF;
            line-height: 19px;
          }
          .p2{
            font-size: 16px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 19px;
          }
          &.animation{
            animation: dongHua 10s 1 ease-in-out;
          }
        }
      }
      .w100{
        width: 80%;
      }
      .line{
        // max-width: 1060px;
        max-width: calc(100% - 196px);
        margin-right: 40px;
        overflow: hidden;
      }
      .maro{
        display: block;
        width: 156px;
        padding-top: 8px;
      }
    }
    .copyRight{
      a{
        text-decoration: none;
        font-size: 14px;
        font-family: Montserrat-Regular, Montserrat;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 18px;
      }
      span{
        font-size: 14px;
        font-family: Montserrat-Regular, Montserrat;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 18px;
      }
      .rights{
        font-size: 14px;
        font-family: Montserrat-Regular, Montserrat;
        font-weight: 400;
        color: rgba(255,255,255,0.5);
        line-height: 18px;
      }
    }
  }
}
// @media screen and (max-width:1919px){
//   .footer{
//     .contain{
//       .lineBox{
//         .line{
//           // max-width: 660px;
//         }
//       }
//     }
//   }
// }
@media screen and (max-width:1439px){
  .footer{
    .contain{
      .three{
        .linkList{
          width: 200px;
        }
      }
    }
  }
}
@media screen and (max-width:1199px){
  .footer{
    .contain{
      .three{
        .linkList{
          width: 190px;
        }
      }
    }
  }
}
@media screen and (max-width:999px){
  .footer{
    // height: 600px;
    .contain{
      padding-top: 50px;
      .three{
        .whiteLogo{
          display: none;
        }
        .whiteLogoMobil{
          display: block;
        }
        .w100{
          width: 100%;
        }
        .linkList{
          margin-bottom: 30px;
          width: 50%;
          ul{
            li{
              margin-bottom: 10px;
              a{
                font-size: 16px;
                line-height: 19px;
              }
            }
          }
        }
        .media{
          width: 100%;
          .tit{
            font-size: 16px;
            line-height: 19px;
            margin-bottom: 13px;
            text-align: left;
          }
          ul{
            max-width: 190px;
            li{
              float: left;
              margin-left: 0;
              margin-right: 12px;
            }
          }
        }
      }
      .lineBox{
        padding-top: 10px;
        .w100{
          width: 100%;
        }
        .line{
          max-width: 100%;
          margin-right: 0;
        }
        .maro{
          display: none;
        }
        .timeList{
          margin-right: 0;
          margin-bottom: 40px;
          width: 100%;
          li{
            .p1{
              font-size: 14px;
              font-family: Montserrat-ExtraLight, Montserrat;
              font-weight: 200;
              color: #FFFFFF;
              line-height: 18px;
              margin-bottom: 4px;
            }
            .p2{
              font-size: 14px;
              font-family: Montserrat-SemiBold, Montserrat;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 18px;
            }
          }
        }
      }
      .copyRight{
        a{
          font-size: 11px;
          line-height: 14px;
        }
        span{
          font-size: 11px;
          line-height: 14px;
        }
        .rights{
          display: block;
          font-size: 11px;
          line-height: 14px;
        }
      }
    }
  }
}
@keyframes dongHua {
  0% {
    opacity: 0;
  }
  5%{
    opacity: 0.3
  }
  20%{
    opacity: 1;
  }
  60%{
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue